/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { NetCDFTimeseriesLeakage } from "./NetCDFTimeseriesLeakage";
import {
  NetCDFTimeseriesLeakageFromJSON,
  NetCDFTimeseriesLeakageFromJSONTyped,
  NetCDFTimeseriesLeakageToJSON,
  NetCDFTimeseriesLeakageToJSONTyped,
} from "./NetCDFTimeseriesLeakage";

/**
 *
 * @export
 * @interface PaginatedNetCDFTimeseriesLeakageList
 */
export interface PaginatedNetCDFTimeseriesLeakageList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<NetCDFTimeseriesLeakage>;
}

/**
 * Check if a given object implements the PaginatedNetCDFTimeseriesLeakageList interface.
 */
export function instanceOfPaginatedNetCDFTimeseriesLeakageList(
  value: object
): value is PaginatedNetCDFTimeseriesLeakageList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedNetCDFTimeseriesLeakageListFromJSON(
  json: any
): PaginatedNetCDFTimeseriesLeakageList {
  return PaginatedNetCDFTimeseriesLeakageListFromJSONTyped(json, false);
}

export function PaginatedNetCDFTimeseriesLeakageListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedNetCDFTimeseriesLeakageList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(NetCDFTimeseriesLeakageFromJSON),
  };
}

export function PaginatedNetCDFTimeseriesLeakageListToJSON(
  json: any
): PaginatedNetCDFTimeseriesLeakageList {
  return PaginatedNetCDFTimeseriesLeakageListToJSONTyped(json, false);
}

export function PaginatedNetCDFTimeseriesLeakageListToJSONTyped(
  value?: PaginatedNetCDFTimeseriesLeakageList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(NetCDFTimeseriesLeakageToJSON),
  };
}
